import { Flex, Box, Image, Text } from "rebass/styled-components";
import useTranslation from "next-translate/useTranslation";

import Heading from "../../common/Heading";
import Button from "../../common/Button";

interface Props {
  onClick: () => void;
}

const Confirmation = ({ onClick }: Props) => {
  const { t } = useTranslation("user/registration");

  return (
    <>
      <Flex
        flexWrap="wrap"
        alignItems="center"
        flexDirection={["column", "column", "row", "row"]}
        width={1}
        mx="auto"
        sx={{ position: "relative", minHeight: ["calc(100vh - 133px)"] }}
      >
        <Box width={[1, 1, "33.3333vw"]} px={[8, 0]}>
          <Image
            src={"/images/registration/done.png"}
            height="auto"
            variant="avatar"
            alt="Gudog"
            width={1}
          />
        </Box>
        <Box
          width={["auto", 1, "33.3333vw"]}
          mt={[4, 4, 0]}
          mb={[8, 0]}
          mx={[2, 0]}
          ml={[0, 0, "16.666vw"]}
          textAlign={["center", "initial"]}
        >
          <Heading as="h1">{t("thankYou")}</Heading>
          <Text as="p" mt={2} mb={3}>
            {t("thankYouDescription")}
          </Text>
          <Box sx={{ display: ["none", "block"] }}>
            <Button onClick={() => onClick()}>{t("search")}</Button>
          </Box>
        </Box>
        <Box
          sx={{
            position: "absolute",
            right: 1,
            bottom: 4,
            left: 1,
            display: ["block", "none"]
          }}
        >
          <Button size="large" width={1} onClick={() => onClick()}>
            {t("search")}
          </Button>
        </Box>
      </Flex>
    </>
  );
};

export default Confirmation;
